<script setup lang="ts">
import { useDispatchDashboardViewStore } from '@/stores/useDispatchDashboardViewStore';
import { dispatchJobsTabs } from '@/constants/tabs';

const dispatchDashboardViewStore = useDispatchDashboardViewStore();
</script>

<template>
  <v-window
    v-model="dispatchDashboardViewStore.query.tab"
    :class="$style.dispatchVWindow"
    data-testid="dispatchVWindow"
    :touch="false"
  >
    <v-window-item
      v-for="(tabValue, tabKey, tabIndex) in dispatchJobsTabs"
      :key="tabIndex"
      :value="tabKey"
      :class="$style.windowItem"
    >
      <slot :tab-value="tabValue" :tab-key="tabKey" :tab-index="tabIndex">
      </slot>
    </v-window-item>
  </v-window>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchVWindow {
  height: 100%;
}
  .windowItem {
    height: 100%;
  }
</style>
